<template>
  <div class="back-container">
    <div class="search-bar">
      <van-search
        v-model="filterForm.orderNo"
        placeholder="搜索回收单号"
        style="flex: 1"
      />
      <van-button size="small" type="primary" @click="search">搜索</van-button>
      <!-- <van-button
        size="small"
        type="primary"
        @click="doBack()"
        class="recycle-button"
      >
        <van-icon name="exchange" class="button-icon" />
        回收
      </van-button> -->

      <div class="recycle-button" @click="doBack()">
        <img
          :src="require('@/assets/huis.jpg')"
          style="
            height: 60px;
            width: 60px;
            object-fit: contain;
            object-position: center;"
          
        />
        <div style="text-align: center;color: #000;font-weight: bold;font-size: 14px">点击回收</div>
      </div>
    </div>
    <van-notice-bar left-icon="volume-o">
      <van-swipe
        class="notice-swipe my-swipe"
        :autoplay="10000"
        indicator-color="white"
        :duration="1000"
      >
        <van-swipe-item
          v-for="(item, index) in noticelItems"
          :key="index"
          @click="noticeClick(item)"
          >{{ item.title }}</van-swipe-item
        >
      </van-swipe>
    </van-notice-bar>
    <van-popup
      :style="{ height: '70%', width: '100%' }"
      v-model:show="noticeShow"
    >
      <div v-html="noticeData"></div>
    </van-popup>

    <div class="back-content">
      <!--      &lt;!&ndash; 状态栏切换 &ndash;&gt;-->
      <!-- <div class="status-tabs">
        <van-tabs v-model:active="activeTab" @change="onStatusChange">
          <van-tab title="评估中" name="1"></van-tab>
          <van-tab title="已评估" name="2"></van-tab>
          <van-tab title="已接收" name="3"></van-tab>
          <van-tab title="已拒绝" name="4"></van-tab>
          <van-tab title="已完成" name="5"></van-tab>
          <van-tab title="已取消" name="6"></van-tab>
        </van-tabs>
      </div> -->

      <div class="card-list" ref="cardList">
        <van-list
          scroller
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多记录"
          @load="onLoad"
        >
          <div
            v-for="item in list"
            :key="item.recyclerId"
            class="recycle-card"
            @click="viewProgress(item)"
          >
            <div class="card-content">
              <!-- 武器图片 -->
              <div class="weapon-image">
                <van-image
                  v-if="item.imgUrl.split(',').length >= 1"
                  :src="item.imgUrl.split(',')[0]"
                  width="80"
                  height="80"
                  fit="contain"
                />
              </div>

              <!-- 回收信息 -->
              <div class="recycle-info">
                <div class="weapon-name" style="font-size: 12px">
                  回收单号:{{ item.orderNo }}
                </div>
                <div class="price-info">
                  <span class="label">回收报价：</span>
                  <span style="color: #ee0a24; font-weight: bold">{{
                    item.assessPrice ? "￥" : "无"
                  }}</span>
                  <span class="price">{{ item.assessPrice }} </span>
                </div>
                <div class="date-info">
                  <span class="label">{{ getDateLabel(item.status) }}：</span>
                  <span class="date">{{ item.createTime }}</span>
                </div>
                <div class="status-badge">
                  <van-tag type="primary" size="medium" v-if="item.status == 1"
                    >评估中</van-tag
                  >
                  <van-tag type="primary" size="medium" v-if="item.status == 2"
                    >已评估</van-tag
                  >
                  <van-tag type="primary" size="medium" v-if="item.status == 3"
                    >已接收</van-tag
                  >
                  <van-tag type="primary" size="medium" v-if="item.status == 4"
                    >已拒绝</van-tag
                  >
                  <van-tag type="primary" size="medium" v-if="item.status == 5"
                    >已完成</van-tag
                  >
                  <van-tag type="primary" size="medium" v-if="item.status == 6"
                    >已取消</van-tag
                  >
                </div>
              </div>

              <!-- 箭头图标 -->
              <div class="arrow-icon">
                <van-icon name="arrow" />
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="height-50"></div>
    <!-- 底部导航 -->

    <!-- <van-tabbar route>
      <van-tabbar-item replace to="/" icon="home-o" >首页</van-tabbar-item>
      <van-tabbar-item replace to="/market"  icon="search">市场</van-tabbar-item>
      <van-tabbar-item replace to="/stock"  icon="shop-o">出售</van-tabbar-item>
      <van-tabbar-item replace to="/back"  icon="after-sale">回收</van-tabbar-item>
      <van-tabbar-item replace to="/proxyPlay"  icon="diamond-o">代充</van-tabbar-item>
      <van-tabbar-item replace to="/profile"  icon="user-o">我的</van-tabbar-item>
    </van-tabbar> -->

    <!--    我要回收 弹出框-->
    <div>
      <van-popup
        v-model:show="showTop"
        position="center"
        :style="{ height: '60%' }"
        round
      >
        <div class="recycle-form">
          <van-cell-group inset>
            <!-- 饰品描述 -->
            <van-field
              v-model="recycleForm.description"
              label="饰品描述"
              type="textarea"
              placeholder="请详细描述您的饰品信息，方便更好的回收报价"
              rows="3"
              maxlength="200"
              show-word-limit
            />

            <!-- 上传图片 -->
            <van-cell title="饰品图片" required>
              <template #default>
                <div class="upload-container">
                  <van-button
                    type="primary"
                    size="small"
                    class="upload-btn"
                    @click="uploadfile"
                    >上传图片</van-button
                  >
                  <span style="font-size: 20px; color: red">{{
                    recycleForm.fileList.length + "/8"
                  }}</span>
                </div>
              </template>
            </van-cell>
            <div class="image-list">
              <van-uploader
                ref="upfile"
                :max-count="8"
                :after-read="afterRead"
                :before-delete="beforeDelete"
                v-model="recycleForm.fileList"
                :show-upload="false"
              >
              </van-uploader>
            </div>
          </van-cell-group>

          <!-- 操作按钮 -->
          <div class="form-actions">
            <van-button
              type="default"
              size="small"
              @click="closeRecycleForm"
              style="margin-bottom: 5px"
            >
              取消
            </van-button>
            <van-button
              type="primary"
              size="small"
              :loading="submitLoading"
              @click="submitRecycleForm"
            >
              确定提交
            </van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
// 在 script 标签顶部添加 Toast 的导入
import { showToast, showDialog } from "vant";
import request from "@/utils/request";
import huishouImg from "@/assets/huis.jpg";
export default {
  name: "BackPage",
  data() {
    return {
      huishouImg: huishouImg,
      list: [],
      filterForm: {},
      textareaVal: "",
      showTop: false,
      submitLoading: false,
      recycleForm: {
        description: "",
        fileList: [],
        contact: "",
      },
      active: 0,
      activeTab: "1",
      productName: "",
      productDesc: "",
      fileList: [],
      estimatedPrice: "待评估",
      evaluationStatus: "评估中",
      finalPrice: "¥1,280",
      canProceed: false,
      // 滚动加载相关
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      showSidebarPopup: false,
      submitTimer: null, // 添加防抖定时器
      noticelItems: [],
      noticeShow: false,
      noticeData: "",
    };
  },
  computed: {
    currentRecycleList() {
      return this.displayData[this.activeTab] || [];
    },
  },
  mounted() {
    // 初始化第一页数据
    //获取喇叭数据内容
    request.get("/front/chat/keywords", { params: { type: 3 } }).then((res) => {
      if (res.code == 200) {
        this.noticelItems = res.data;
        this.noticelItems = this.noticelItems.filter((item) => item.type == 3);
      }
    });
  },
  methods: {
    extractAndStyleImages(htmlString) {
      // 匹配所有img标签的正则表达式
      const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
      const images = [];
      let match;

      // 提取所有img标签
      while ((match = imgRegex.exec(htmlString)) !== null) {
        images.push({
          originalTag: match[0], // 原始img标签
          src: match[1], // 图片地址
          index: match.index, // 在字符串中的位置
        });
      }

      return images;
    },
    processHTMLWithStyledImages(htmlString) {
      // 提取所有图片
      const images = this.extractAndStyleImages(htmlString);
      let processedHTML = htmlString;

      // 为每个img标签添加样式
      images.forEach((img) => {
        const styledImgTag = `<img src="${img.src}" style="max-width: 100%; height: auto;" alt="饰品图片">`;
        processedHTML = processedHTML.replace(img.originalTag, styledImgTag);
      });

      return processedHTML;
    },

    noticeClick(data) {
      this.noticeData = data.content;
      this.noticeData = this.processHTMLWithStyledImages(this.noticeData);
      this.noticeShow = true;
    },
    // 添加防抖函数
    getUploadFile(fileItem) {
      return fileItem.file || fileItem.content || fileItem.raw || fileItem.rawFile || null;
    },
    debounceSubmit(callback, delay = 1000) {
      if (this.submitTimer) {
        clearTimeout(this.submitTimer);
      }
      this.submitTimer = setTimeout(async () => {
        try {
          await callback();
        } finally {
          this.submitTimer = null;
        }
      }, delay);
    },
    onLoad() {
      console.log("进来了");
      if (this.finished) {
        return false;
      }
      setTimeout(() => {
        this.page++;
        this.getList();
      }, 500);
    },
    search() {
      this.finished = false;
      this.list = [];
      this.page = 1;
      this.getList();
    },
    getList() {
      if (this.finished) {
        return false;
      }
      request
        .get("/front/platform/recycler/list", {
          params: {
            orderNo: this.filterForm.orderNo,
            // status:this.activeTab,
            pageNum: this.page,
            pageSize: 10,
          },
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            // console.log(res)
            if (this.page == 1) {
              this.list = [];
              this.list = res.rows;
            } else {
              this.list = [...this.list, ...res.rows];
            }
            // 判断是否还有更多数据
            this.finished = this.list.length >= res.total;
            console.log(this.list.length);
            console.log(res.total);
          } else {
            this.finished = true;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //我要回收
    doBack() {
      this.recycleForm = {
        fileList: [],
      };
      this.showTop = true;
    },

    // 状态切换
    onStatusChange(name) {
      this.activeTab = name;
      this.page = 0;
      this.finished = false;
      this.getList();
    },

    // 查看回收进度
    viewProgress(item) {
      // 这里可以跳转到详情页面
      this.$router.push(`/backProcess?recyclerId=${item.recyclerId}`);
    },

    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        processing: "primary",
        recycled: "success",
        rejected: "danger",
        completed: "success",
      };
      return typeMap[status] || "default";
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        processing: "回收中",
        recycled: "已回收",
        rejected: "已拒绝",
      };
      return textMap[status] || "未知状态";
    },

    // 获取日期标签
    getDateLabel(status) {
      const labelMap = {
        processing: "提交日期",
        recycled: "回收日期",
        rejected: "拒绝日期",
        completed: "完成日期",
      };
      return labelMap[status] || "日期";
    },
    // 关闭回收表单
    closeRecycleForm() {
      this.showTop = false;
      // 重置表单数据
      this.recycleForm = {
        description: "",
        fileList: [],
        contact: "",
      };
    },

    // 图片上传后的回调
    afterRead(raw) {
      // console.log(raw)
    },
    uploadfile() {
      this.$refs.upfile.chooseFile();
    },

    // 删除图片前的回调
    beforeDelete(file, detail) {
      // 找到要删除的文件索引
      const index = this.recycleForm.fileList.findIndex(
        (item) => item.url === file.url
      );
      if (index !== -1) {
        // 只删除指定的文件
        this.recycleForm.fileList.splice(index, 1);
      }
      return true;
    },

    // 提交回收表单
    async submitRecycleForm() {
      if (this.submitLoading) {
        return;
      }
      // 表单验证
      if (!this.recycleForm.fileList.length) {
        showToast("请上传至少一张图片");
        return;
      }
      this.submitLoading = true;
      this.debounceSubmit(async () => {
        try {
          const imageUrls = [];
          const failedFiles = [];

          for (const fileItem of this.recycleForm.fileList) {
            const file = this.getUploadFile(fileItem);
            if (!file) {
              failedFiles.push(fileItem);
              continue;
            }

            const formData = new FormData();
            formData.append("file", file);

            try {
              const res = await request.post("/common/recycler/upload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              });

              if (res && res.code === 200 && res.url) {
                imageUrls.push(res.url);
              } else {
                failedFiles.push(fileItem);
              }
            } catch (uploadError) {
              failedFiles.push(fileItem);
            }
          }

          if (!imageUrls.length) {
            throw new Error("所有图片上传失败，请检查网络后重试");
          }

          const createResult = await request.post(
            "/front/platform/recycler/create",
            {
              imgUrls: imageUrls,
              descriptions: this.recycleForm.description,
            }
          );

          if (createResult.code === 200) {
            if (failedFiles.length) {
              showToast("部分图片上传失败，已提交成功。可重新上传失败图片。");
            } else {
              showToast("提交成功");
            }
            this.showTop = false;
            this.recycleForm.description = "";
            this.recycleForm.fileList = [];
            this.search();
          } else {
            throw new Error(createResult.msg || "提交失败");
          }
        } catch (error) {
          showToast(error.message || "上传失败，请重试");
        } finally {
          this.submitLoading = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.back-container {
  background-color: #f7f8fa;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.steps-container {
  background: white;
  margin-bottom: 10px;
}

.step-number {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-color: #ebedf0;
  color: #969799;
  font-size: 12px;
}

/* 新增样式 */
.back-content {
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  min-height: 0; /* 重要：允许flex子项收缩 */
}

.status-tabs {
  background: white;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
}

.card-list {
  overflow-y: scroll;
}

.empty-state {
  background: white;
  padding: 40px 20px;
  border-radius: 8px;
  text-align: center;
}

.recycle-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.recycle-card:active {
  transform: scale(0.98);
  /* background-color: #f8f9fa; */
}

.card-content {
  display: flex;
  align-items: center;
}

.weapon-image {
  margin-right: 12px;
  border-radius: 6px;
  overflow: hidden;
}

.recycle-info {
  flex: 1;
  min-width: 0;
}

.weapon-name {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.price-info,
.date-info {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  font-size: 14px;
}

.label {
  color: #969799;
  margin-right: 4px;
}

.price {
  color: #ee0a24;
  font-weight: 600;
}

.date {
  color: #323233;
}

.status-badge {
  margin-top: 8px;
}

.arrow-icon {
  color: #323233;
  margin-left: 8px;
}

.success-info p {
  margin: 8px 0;
  color: #323233;
}

.action-buttons {
  padding: 16px;
  background: white;
  display: flex;
  gap: 12px;
}

.action-buttons .van-button {
  flex: 1;
}

.card-list {
  overflow-y: auto;
  flex: 1;
  /* 自定义滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
}

.card-list::-webkit-scrollbar {
  width: 6px;
}

.card-list::-webkit-scrollbar-track {
  background: transparent;
}

.card-list::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

.card-list::-webkit-scrollbar-thumb:hover {
  background-color: #a1a1a1;
}

/* 加载更多样式 */
.loading-more {
  padding: 20px;
  text-align: center;
  color: #969799;
}

.no-more {
  padding: 20px 0;
  text-align: center;
}

/* 回收表单样式 */
.recycle-form {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebedf0;
}

.form-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.form-actions {
  padding: 20px 0;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* 上传组件样式优化 */

.search-bar {
  background: white;
  padding: 10px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;
}
.search-icon {
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar-form {
  padding: 18px 10px 10px 10px;
}

.ad-container {
  width: 100%;
  height: 50px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ad-image {
  width: 100%;
  border-radius: 4px;
  object-fit: contain;
}

.recycle-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  position: fixed;
  bottom: 70px;
  right: 10px;
  /* background: linear-gradient(45deg, #1989fa, #4bb0ff); */
  background-color: #ffffff;
  border: none;
  z-index: 100;
  width: 70px;
  height: 80px;
}

.recycle-button:active {
  transform: scale(0.95);
  box-shadow: 0 1px 3px rgba(25, 137, 250, 0.3);
}

.button-icon {
  margin-right: 4px;
  vertical-align: -2px;
}

.upload-container {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.upload-btn {
  flex-shrink: 0;
}

.image-list {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
  padding: 4px 0;
}

.image-list :deep(.van-uploader__wrapper) {
  display: inline-flex;
}

.image-list :deep(.van-uploader__preview) {
  margin-right: 8px;
  margin-bottom: 0;
}

.my-swipe .van-swipe-item {
  width: 100%;
  text-decoration: underline;
}
</style>
